(function () {
  if (window.CarlProductCardImpacts) return;
  window.CarlProductCardImpacts = true;

  const OPEN_CLASS = 'impacts-open';
  const DISMISSED_CLASS = 'impacts-dismissed';

  function setOpen(card, open) {
    const trigger = card.querySelector('[data-impacts-trigger]');
    if (!trigger || !card.querySelector('.product-card-impacts')) return;

    card.classList.toggle(OPEN_CLASS, open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function undismiss(card) {
    card.classList.remove(DISMISSED_CLASS);
  }

  /*
    In hover mode the panel is revealed by CSS while the pointer is inside the
    card, so closing has to suppress that until the pointer leaves.
  */
  function dismiss(card) {
    setOpen(card, false);
    card.classList.add(DISMISSED_CLASS);
    card.addEventListener('mouseleave', () => undismiss(card), { once: true });
  }

  function closeAll(except) {
    document.querySelectorAll('.card-wrapper.' + OPEN_CLASS).forEach((card) => {
      if (card !== except) setOpen(card, false);
    });
  }

  function closeAndRefocus(card) {
    dismiss(card);
    const trigger = card.querySelector('[data-impacts-trigger]');
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-impacts-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      const card = trigger.closest('.card-wrapper');
      if (!card) return;
      const shouldOpen = !card.classList.contains(OPEN_CLASS);
      closeAll(card);
      undismiss(card);
      setOpen(card, shouldOpen);
      return;
    }

    const closeButton = event.target.closest('[data-impacts-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      const card = closeButton.closest('.card-wrapper');
      if (card) closeAndRefocus(card);
      return;
    }

    if (!event.target.closest('.product-card-impacts')) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const card =
      document.querySelector('.card-wrapper.' + OPEN_CLASS) ||
      document.querySelector('.card-wrapper[data-impacts-mode="hover"]:hover');
    if (card) closeAndRefocus(card);
  });
})();
